document.addEventListener("DOMContentLoaded", function () {
  const currency = window.Shopify?.currency?.active || "EUR";

  function getCartValue() {
    let totalSpan = document.querySelector(".totals__subtotal-value") || document.querySelector(".cart_totals-value");
    if (!totalSpan) return 0;
    return parseFloat(totalSpan.textContent.trim().replace(/[€\s]/g, "").replace("EUR", "").replace(/\./g, "").replace(",", ".")) || 0;
  }

  async function extractProductId(variantId, productData) {
    let pId = productData?.product_id || productData?.featured_image?.product_id;
    if (!pId && productData?.variants) pId = productData.id;
    if (pId) return String(pId);

    try {
      const variantInput = document.querySelector(`input[name="id"][value="${variantId}"], select[name="id"] option[value="${variantId}"]`);
      if (variantInput) {
        const form = variantInput.closest('form');
        if (form) {
          const productInput = form.querySelector('input[name="product-id"], input[name="product_id"]');
          if (productInput && productInput.value) return String(productInput.value);
        }
      }
    } catch(e) {}

    if (window.meta?.product?.id) return String(window.meta.product.id);
    if (window.ShopifyAnalytics?.meta?.product?.id) return String(window.ShopifyAnalytics.meta.product.id);

    if (window.location.pathname.includes('/products/')) {
      try {
        const res = await fetch(window.location.pathname.split('?')[0] + '.js');
        const data = await res.json();
        if (data.id) return String(data.id);
      } catch(e) {}
    }

    return "undefined";
  }

  async function pushAddToCartEvent(variantId, quantity, productData) {
    if (!variantId || !productData) return;
    const maxPrice = productData.compare_at_price || productData.price;
    const finalPrice = productData.price;
    const discount = Math.max(0, maxPrice - finalPrice);
    const cartValue = getCartValue();

    const productId = await extractProductId(variantId, productData);
    const itemId = (productId !== "undefined" && productId != null) ? `shopify_ZZ_${productId}_${variantId}` : `shopify_ZZ_undefined_${variantId}`;

    const eventData = {
      event: "add_to_cart",
      ecommerce: {
        currency: productData.currency || currency,
        value: cartValue,
        items: [{
            item_id: itemId,
            item_name: productData.title,
            item_brand: productData.vendor,
            price: finalPrice,
            quantity: quantity,
            discount: discount,
          }]
      }
    };
  }

  document.addEventListener("card-product:add-to-cart", function (e) {
    const { variantId, quantity, productData } = e.detail;
    if (variantId && productData) pushAddToCartEvent(variantId, quantity || 1, productData);
  });
});